

const ink403 = {
  template: `
  <h1>Sorry, this content isn’t available right now.</h1>
  <p>The link you followed may have expired, or the page may only be visible to
  an audience you're not in.</p>
  `
};

angular
  .module('inkfinder')
  .component('ink403', ink403);



// WEBPACK FOOTER //
// ./common/403/403.component.js